import { render, staticRenderFns } from "./ApproveIncentiveDialog.vue?vue&type=template&id=54bc2570&"
import script from "./ApproveIncentiveDialog.vue?vue&type=script&lang=js&"
export * from "./ApproveIncentiveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports